/**
 * Lithuanian phone number formatter
 * Formats phone inputs with +370 prefix
 * Replaces cleave.js with vanilla JS
 */

export default (() => {
  const phoneInputs = document.querySelectorAll(
    'input[type="tel"], [data-phone-format]',
  );

  if (phoneInputs.length === 0) return;

  const formatLithuanianPhone = (value) => {
    // Remove all non-digit characters
    let digits = value.replace(/\D/g, "");

    // Remove leading zeros
    digits = digits.replace(/^0+/, "");

    // If starts with 370, remove it (we'll add it back formatted)
    if (digits.startsWith("370")) {
      digits = digits.substring(3);
    }

    // Limit to 8 digits (Lithuanian mobile numbers after +370)
    digits = digits.substring(0, 8);

    // Format as +370 XXX XXXXX
    if (digits.length === 0) {
      return "";
    }

    let formatted = "+370 ";

    if (digits.length <= 3) {
      formatted += digits;
    } else {
      formatted += digits.substring(0, 3) + " " + digits.substring(3);
    }

    return formatted;
  };

  const handleInput = (e) => {
    const input = e.target;
    const cursorPosition = input.selectionStart;
    const oldValue = input.value;
    const oldLength = oldValue.length;

    // Format the value
    const formatted = formatLithuanianPhone(oldValue);
    input.value = formatted;

    // Adjust cursor position
    const newLength = formatted.length;
    const diff = newLength - oldLength;
    let newPosition = cursorPosition + diff;

    // Ensure cursor doesn't go before the prefix
    if (newPosition < 5 && formatted.length > 0) {
      newPosition = 5; // After "+370 "
    }

    // Set cursor position after value update
    requestAnimationFrame(() => {
      input.setSelectionRange(newPosition, newPosition);
    });
  };

  const handleFocus = (e) => {
    const input = e.target;
    // If empty, show the prefix
    if (!input.value || input.value.trim() === "") {
      input.value = "+370 ";
      // Move cursor to end
      requestAnimationFrame(() => {
        input.setSelectionRange(input.value.length, input.value.length);
      });
    }
  };

  const handleBlur = (e) => {
    const input = e.target;
    // If only prefix remains, clear the field
    if (input.value.trim() === "+370" || input.value.trim() === "+370 ") {
      input.value = "";
    }
  };

  const handleKeyDown = (e) => {
    const input = e.target;
    const cursorPosition = input.selectionStart;

    // Prevent deleting the prefix
    if (cursorPosition <= 5 && (e.key === "Backspace" || e.key === "Delete")) {
      if (cursorPosition < 5) {
        e.preventDefault();
      }
    }
  };

  phoneInputs.forEach((input) => {
    // Remove old data-input-format attribute if present
    input.removeAttribute("data-input-format");

    // Set placeholder
    if (!input.placeholder || input.placeholder.includes("___")) {
      input.placeholder = "+370 XXX XXXXX";
    }

    // Format existing value if present
    if (input.value && input.value.trim() !== "") {
      input.value = formatLithuanianPhone(input.value);
    }

    // Add event listeners
    input.addEventListener("input", handleInput);
    input.addEventListener("focus", handleFocus);
    input.addEventListener("blur", handleBlur);
    input.addEventListener("keydown", handleKeyDown);
  });
})();
